<template>
  <project-layout :projectName="this.$options.name">
    <p>Collision: The Dark War is a fake movie trailer made by editing 20 different movies. The scenes and sounds are mostly excerpted from the movie trailers downloaded from HD-Trailers(hd-trailers.net), and the background music is Mind Heist by Zack Hemsey (music.zackhemsey.com/album/mind-heist).</p>
    <div class="embed"><figure><iframe src="https://player.vimeo.com/video/97084600?color=ffffff&title=0&byline=0&portrait=0" width="1140" height="641" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></figure></div>
  </project-layout>  
</template>

<script>
  import ProjectLayout from '@/layouts/ProjectLayout.vue'
  import DataPath from '@/components/DataPath.vue'

  export default {
    name: 'collision',
    components: {
      'project-layout': ProjectLayout
    },
    data () {
      return {
        imagePath: '',
        videoPath: ''
      }
    },
    created () {
      this.imagePath = DataPath.data().imagePath + this.$options.name + '/'
      this.videoPath = DataPath.data().videoPath + this.$options.name + '/'
    }
  }
</script>

<style lang="sass" scoped>
</style>


// WEBPACK FOOTER //
// src/contents/Collision.vue